import React, { useState } from "react";
import {
  Card,
  FormLayout,
  TextField,
  Checkbox,
  Button,
  BlockStack,
} from "@shopify/polaris";

const FilterBar = ({ filters, onFilterChange, onRefresh }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleStartDateChange = (value) => {
    setLocalFilters({ ...localFilters, start_date: value });
  };

  const handleEndDateChange = (value) => {
    setLocalFilters({ ...localFilters, end_date: value });
  };

  const handleIncludeManualChange = (value) => {
    setLocalFilters({ ...localFilters, include_manual: value });
  };

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      start_date: "",
      end_date: "",
      include_manual: false,
      repeat_type: "basic",
    };
    setLocalFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  // Quick date range presets
  const handleQuickRange = (days) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);

    const newFilters = {
      ...localFilters,
      start_date: startDate.toISOString().split("T")[0],
      end_date: endDate.toISOString().split("T")[0],
    };
    setLocalFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <Card>
      <div style={{ padding: "16px" }}>
        <BlockStack gap="400">
          <FormLayout>
            <FormLayout.Group>
              <TextField
                label="Start Date"
                type="date"
                value={localFilters.start_date}
                onChange={handleStartDateChange}
                autoComplete="off"
              />
              <TextField
                label="End Date"
                type="date"
                value={localFilters.end_date}
                onChange={handleEndDateChange}
                autoComplete="off"
              />
            </FormLayout.Group>

            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <Button size="slim" onClick={() => handleQuickRange(7)}>
                Last 7 Days
              </Button>
              <Button size="slim" onClick={() => handleQuickRange(30)}>
                Last 30 Days
              </Button>
              <Button size="slim" onClick={() => handleQuickRange(90)}>
                Last 90 Days
              </Button>
              <Button
                size="slim"
                onClick={() => {
                  const today = new Date().toISOString().split("T")[0];
                  const newFilters = {
                    ...localFilters,
                    start_date: today,
                    end_date: today,
                  };
                  setLocalFilters(newFilters);
                  onFilterChange(newFilters);
                }}
              >
                Today
              </Button>
            </div>

            <Checkbox
              label="Include manual orders (admin-added)"
              checked={localFilters.include_manual}
              onChange={handleIncludeManualChange}
              helpText="By default, only real sales (MyFatoorah & RevenueCat) are shown"
            />
          </FormLayout>

          <div style={{ display: "flex", gap: "8px" }}>
            <Button variant="primary" onClick={handleApplyFilters}>
              Apply Filters
            </Button>
            <Button onClick={handleClearFilters}>Clear Filters</Button>
            <Button onClick={onRefresh}>Refresh Data</Button>
          </div>
        </BlockStack>
      </div>
    </Card>
  );
};

export default FilterBar;
